import React from 'react'

export default function CompanyRightPane(): React.JSX.Element {
    // TODO : Handle company id not found
    // const companyId = state.selectedCompanyId!
    // const company = state.companyCache.get(companyId)
    // if (!company) {
    //     throw new Error(
    //         `Company not found in CompanyRightPane for id: ${companyId}`,
    //     )
    // }
    // return (
    //     <div>
    //         <div className="flex items-center gap-4 mt-4">
    //             <img
    //                 src={company.logoUrl}
    //                 alt={company.name}
    //                 className="w-16 h-16 object-cover border"
    //             />
    //             <div>
    //                 <h3 className="font-semibold text-lg">{company.name}</h3>
    //             </div>
    //         </div>
    //     </div>
    // )
    return <div>Company pane not implemented</div>
}
